var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.variant_name || !_vm.rendered
      ? _c("p", [
          _vm._v(
            "\n    Please select a variant in order to generate a PheWAS plot. You can click on any scatter plot\n    point in an association track.\n  "
          ),
        ])
      : _c(
          "div",
          [
            _c("h3", [
              _vm._v("Known PheWAS Results: " + _vm._s(_vm.variant_name)),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n      In your study "),
              _c("em", { staticStyle: { "word-break": "break-word" } }, [
                _vm._v(_vm._s(_vm.your_study)),
              ]),
              _vm._v(", this variant has a\n      "),
              _c(
                "span",
                {
                  staticClass: "text-muted definition",
                  attrs: { title: "p-value " + _vm.display_pvalue },
                },
                [
                  _vm._v("\n        -log"),
                  _c("sub", [_vm._v("10")]),
                  _vm._v(" p-value of "),
                  _c("strong", [_vm._v(_vm._s(_vm.display_logpvalue))]),
                ]
              ),
              _vm._v(". Below are other\n      results for comparison.\n    "),
            ]),
            _vm._v(" "),
            _c("lz-plot", {
              ref: "phewas_plot",
              attrs: {
                base_layout: _vm.base_phewas_layout,
                base_sources: _vm.base_phewas_sources,
                show_loading: true,
              },
              on: { connected: _vm.receivePlot },
            }),
          ],
          1
        ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n    PheWAS results are drawn from a large-scale analysis of the UK Biobank dataset, as described in\n    "
      ),
      _c(
        "a",
        { attrs: { href: "https://doi.org/10.1038/s41588-018-0184-y" } },
        [_vm._v("Nature Genetics volume 50, pages 1335–1341 (2018)")]
      ),
      _vm._v(".\n  "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }